<template>
  <BaseEventAware :ignore="true">
    <modal
      id="missionModal"
      name="mission"
      class="relative"
      :adaptive="true"
      :click-to-close="false"
      :shift-y="0"
      height="100%"
      @closed="closed"
    >
      <div class="container flex flex-col items-center h-full p-10 mx-auto" @click="close">
        <div class="flex-none">
          <div class="flex items-center py-4 sm:py-10">
            <div class="px-2">
              <BaseImg v-if="logo" :src="logo" class="h-24 mx-auto mb-4 sm:h-40 v:h-48" />
            </div>
            <div class="px-2">
              <!-- eslint-disable -->
              <h2 class="pt-4 text-2xl font-black text-center sm:pt-12 sm:text-4xl" v-html="title"></h2>
              <p class="pb-4 mt-1 text-xl font-bold text-center sm:pb-12 sm:text-3xl">
                {{ modeText }}
              </p>
            </div>
          </div>
        </div>
        <!--end::title-->

        <div class="flex items-center justify-center flex-1 w-full box sm:mb-10">
          <!-- eslint-disable -->
          <div class="py-4 sm:py-10">
            <p class="p-6 text-lg font-bold sm:text-4xl" v-html="gameMode.mission"></p>
          </div>
        </div>
        <!--end::content-->

        <div class="flex-none w-full">
          <div class="mt-10">
            <p class="w-full py-4 text-lg font-bold text-center text-white sm:py-8 sm:text-3xl start">
              화면을 눌러주세요.
            </p>
          </div>
        </div>
        <!--end::footer-->
      </div>
    </modal>
  </BaseEventAware>
</template>

<script>
import * as _ from 'lodash'
import { EVENT, MODE, PLAY_STATUS, PLAY_TIMER } from '@src/games/constant'
import { mapGetters } from 'vuex'
import { PLAYS } from '@state/modules/play'
import { GAMES } from '@state/modules/game'
import TTS from '@utils/browser-tts'

export default {
  data() {
    return {
      gameMode: {},
      tts: new TTS({ rate: 0.9 }),
      logo: '',
    }
  },
  computed: {
    ...mapGetters(PLAYS.NAME, [PLAYS.GET_PLAY, PLAYS.GET_PLAY_MODE, PLAYS.GET_PLAY_CONFIG]),
    ...mapGetters(GAMES.NAME, [GAMES.GET_GAME_MODES]),
    title() {
      return _.get(this.GET_PLAY, 'descriptions[0]')
    },
    modeText() {
      switch (this.GET_PLAY_MODE) {
        case MODE.BEGINNER:
          return '초급편'
        case MODE.INTERMEDIATE:
          return '중급편'
        case MODE.ADVANCED:
          return '고급편'
        default:
          this.$log.error('unexpected mode : ', this.GET_PLAY_MODE)
          window.location.href = '/'
          return ''
      }
    },
  },
  beforeMount() {
    this.gameMode = this.GET_GAME_MODES[this.GET_PLAY_MODE]
    this.$events.on(EVENT.PLAY_GAME_READY, this.opened)
    this.logo = this.GET_PLAY_CONFIG.logo
  },
  mounted() {
    const index = this.$route.query.index
    if (!index) {
      this.$modal.show('mission')
    }
  },
  beforeDestroy() {
    this.$events.off(EVENT.PLAY_GAME_READY, this.opened)
  },
  methods: {
    opened() {
      // play tts
      if (this.gameMode.tts) {
        setTimeout(() => {
          this.tts.play(this.gameMode.tts)
        }, 1000)
      }
    },
    closed() {
      if (this.tts) {
        this.tts.stop()
        this.$store.commit(PLAYS.NAMESPACE(PLAYS.SET_START_TIME), Date.now())
      }
    },
    close() {
      this.$store.commit(PLAYS.NAMESPACE(PLAYS.SET_PLAY_STATUS), PLAY_STATUS.START)
      this.$events.emit(PLAY_TIMER.START)
      this.$events.emit(EVENT.PLAY_STATUS_START)
      this.$modal.hide('mission')
      this.closed()
    },
  },
}
</script>

<style lang="scss">
#missionModal {
  .vm--modal {
    overflow-y: scroll !important;
  }

  .vm--overlay {
    background: #fff1c1 !important;
  }
}
</style>

<style scoped>
.box {
  background-color: white;
  border: 1px solid #dbd5c3;
}

.start {
  background-color: #383533;
}
</style>
